export function contains<T>(arr: T[], el: T): boolean {
    for (const element of arr) {
        if (element === el) {
            return true;
        }
    }
    return false;
}
